import { render } from "./Invites.vue?vue&type=template&id=0383bd6e&scoped=true"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"

import "./custom-invites.scss?vue&type=style&index=0&id=0383bd6e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0383bd6e"]])

export default __exports__